import {  requestForWonFeedback } from "api/Appointment";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

export const useWonFeedback = () => {
  const queryClient = useQueryClient();
  return useMutation(requestForWonFeedback, {
    onSuccess: () => {
      queryClient.invalidateQueries('appointments');
      queryClient.invalidateQueries(['widgetData', 'Upcoming Appointments'])
      toast.success("Status Won Choosed Successfully");
    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
